import { render } from "./ParallaxBg.vue?vue&type=template&id=5a7731ee"
import script from "./ParallaxBg.vue?vue&type=script&lang=js"
export * from "./ParallaxBg.vue?vue&type=script&lang=js"

import "./ParallaxBg.vue?vue&type=style&index=0&id=5a7731ee&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__